export default {
  cloud_name: "dkz9kcsqy",
  // cloud_name: "db7cuh33j",
  upload_preset: "quickStreet",
};
